import { createDataContext } from '../../../context/DataContext';
import { PolicySummary } from '../../../Interfaces/Insurance/Policy';

export const {
  DataContextProvider: PolicySummaryProvider,
  useDataContext: usePolicySummaryContext,
} = createDataContext<PolicySummary>();
